import { useTrads } from "../../contexts/trads/useTrads";
import { getByPath, uniqid } from "../../tools/utils";
import { statusDispo, type demandeStatus } from "../../types/Demande";
import type { SelectProps } from "../../types/Interface";
import type { FieldError } from "react-hook-form";

interface PlusStatut {
    statut:demandeStatus
};
type StatutSelectProps = SelectProps & PlusStatut

export function StatutSelectorBootstrap({name, label, registerOutput, errors, statut}:StatutSelectProps){
    const id=uniqid(name);
    const field_errors=getByPath(errors,name) as FieldError[];
    const {translate}=useTrads();
    return (
        <>
        <div className={ "form-floating " +  (errors[name] ? " is-invalid":'')}>
                <select className={"form-select "+ (errors[name]? " is-invalid":'')} id={id}
                 {...registerOutput} 
                >
                    <option value="">-----</option>
                    {statusDispo(statut).map((key)=>
                       <option value={key} key={key}>{translate(key)}</option>
                    )}
                </select>
                <label className="form-label" htmlFor={id}>{label}</label>
                
        </div>
        {field_errors.length > 0 && <div className="invalid-feedback">{field_errors.map((error)=> 
                <p key={error.message} role="alert">{translate(error.message)}</p>)
            }</div>}
        </>
    );
}